import type {FC} from "react";
import {DescriptionText} from "../../price-page.styles";
import {Subtitle, TextWrapper} from "../description/description.styles";
import {CardGroup} from "./card-block.styled";
import CardImg1 from "@src/core/images/tariff-small.jpg";
import CardImg2 from "@src/core/images/tariff-light.jpg";
import CardImg3 from "@src/core/images/tariff-medium.jpg";
import CardImg4 from "@src/core/images/tariff-large.jpg";
import {Card} from "../card";

export const CardBlock: FC = () => {

    return (
        <div>
            <TextWrapper>
                <Subtitle id="price">Расширенные возможности</Subtitle>
                <DescriptionText>
                    В бесплатный тариф входят 5 API методов и 60 запросов в минуту. Если этого недостаточно, ниже
                    представлены тарифные планы, которые расширяют возможности сервиса.
                </DescriptionText>
            </TextWrapper>

            <CardGroup>
                <Card
                    title="Small"
                    badgeColor="blue"
                    badgeText="Экономно"
                    src={CardImg1}
                    period="На месяц"
                    api={100}
                    requests={300}
                    buttonText="Купить за 800 ₽"
                    handleButton={2}
                />
                <Card
                    title="Light"
                    src={CardImg2}
                    period="На 3 месяца"
                    api={200}
                    requests={300}
                    buttonText="Купить за 2 200 ₽"
                    handleButton={3}
                />
                <Card
                    title="Medium"
                    badgeColor="green"
                    badgeText="Выгодно"
                    src={CardImg3}
                    period="На 6 месяцев"
                    api={400}
                    requests={300}
                    buttonText="Купить за 4 300 ₽"
                    handleButton={4}
                />
                <Card
                    title="Large"
                    badgeColor="green"
                    badgeText="Выгодно"
                    src={CardImg4}
                    period="Год"
                    api={750}
                    requests={400}
                    buttonText="Купить за 9 100 ₽"
                    handleButton={5}
                />
            </CardGroup>
        </div>
    );
};
